import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=83e87b36&"
import script from "./Timestamp.vue?vue&type=script&lang=ts&"
export * from "./Timestamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports